export default __webpack_public_path__ + "static/media/euro.d2939f7a.svg";